import { Button, Card, CardContent, CardHeader, CardTitle, Input, Label } from "@repo/ui";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

interface Item {
  id: number;
  name: string;
  surname: string;
  phone: string;
  email: string;
  created_at: string;
}

export default function LookupPage() {
  const navigate = useNavigate();
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [item, setItem] = useState<Item | null>(null);

  const onLookup = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setItem(null);
    if (!phone.trim()) {
      setError("กรุณากรอกเบอร์โทร / Enter phone number");
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(
        `/api/registrations/lookup?phone=${encodeURIComponent(phone.trim())}`
      );
      if (!res.ok) throw new Error("Not found");
      const data = (await res.json()) as { item: Item };
      setItem(data.item);
    } catch {
      setError("ไม่พบข้อมูล / Not found");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center p-6">
      <Card className="w-full max-w-md">
        <CardHeader>
          <div className="flex items-center justify-between">
            <CardTitle>Look up registration by phone</CardTitle>
            <Button variant="outline" onClick={() => navigate("/")}>
              Back
            </Button>
          </div>
        </CardHeader>
        <CardContent className="space-y-4">
          <form onSubmit={onLookup} className="space-y-3">
            <div className="space-y-2">
              <Label htmlFor="phone">Phone เบอร์โทรศัพท์มือถือ</Label>
              <Input id="phone" value={phone} onChange={(e) => setPhone(e.target.value)} />
            </div>
            {error && <p className="text-sm text-red-600">{error}</p>}
            <Button type="submit" disabled={loading} className="w-full">
              {loading ? "Searching..." : "Search"}
            </Button>
          </form>

          {item && (
            <div className="space-y-3">
              <div className="text-sm">
                <div>
                  {item.name} {item.surname}
                </div>
                <div className="text-muted-foreground">ID: {item.id}</div>
              </div>
              <div className="flex flex-col items-center gap-3">
                <img
                  alt="QR Code"
                  className="size-40"
                  src={`https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(String(item.id))}`}
                />
                <Button onClick={() => navigate(`/coupon/${item.id}`)}>
                  ตอบคำถามเพิ่มเพื่อรับ Coupon
                </Button>
              </div>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
